module.exports = (__webpack_require__(1))("./pages/wxsys/lib/base/initenv.js");


//////////////////
// WEBPACK FOOTER
// delegated ./pages/wxsys/lib/base/initenv.js from dll-reference wxcomp
// module id = 142
// module chunks = 22